export default function ContentDividerSvg({fillColour}) {
	return (
		<svg width="100%" height="auto" viewBox="0 0 1920 250" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M927.359 68.6863C1437.74 -16.4665 1920 119.905 1920 119.905V250H0V0C0 0 416.976 153.839 927.359 68.6863Z" fill={fillColour} />
		</svg>
	)
}